import React, { ReactNode } from 'react';
import { ButtonVariant } from '../../../../../types/types';

interface ActionButton {
  label: ReactNode;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  variant: ButtonVariant;
  disabled?: boolean;
}

interface CouponBottomActionsProps {
  actions: ActionButton[];
}

const CouponBottomActions: React.FC<CouponBottomActionsProps> = ({ actions }) => {
  if (actions.length === 0) {
    return null;
  }

  return (
    <div className="flex items-center justify-end gap-0">
      {actions.map((action, index) => (
        <button
          key={index}
          type="button"
          className={`${action.variant} sm flex items-center justify-center gap-1 ${action.variant !== ButtonVariant.NONE ? '' : 'coupon-action-button'}`}
          onClick={(e) => action.onClick(e)}
          disabled={action.disabled}
        >
          {action.label}
        </button>
      ))}
    </div>
  );
};

export default CouponBottomActions;

